import { Button, Link, TableCell, TableHead, TableRow } from "@mui/material";
import { useCreateMetadataMutation, useGetSKUMetadataQuery } from "../features/products/metadataSlice";
import { MetadataEditor } from "./ProductMetadataView";
import AddIcon from '@mui/icons-material/Add';

const ProductHeader = () => {
    return <TableHead>
        <TableCell>SKU</TableCell>
        <TableCell>Name</TableCell>
        <TableCell>Stock</TableCell>
        <TableCell>Type</TableCell>
        <TableCell>Weight (oz)</TableCell>
    </TableHead>;
}

const ProductRow = ({product, editing}) => {
    const { data: metadatas, error: metadatasError, isLoading: metadatasAreLoading} = useGetSKUMetadataQuery(product ? product.id : null, {skip: !product});
    const [addMeta] = useCreateMetadataMutation();
    if (metadatas) {
      var md_per_key = {};
  
      metadatas.objects.forEach((md) => {
          md_per_key[md.key] = md;
      });
    }
  
    const makeLinkToProduct = (product) => {
      return `/products/${product.product_family}/${product.id}/edit`
    }

    function mdForKey(key) {
        var md = null;
        if(!metadatas) return null;
        if(key in md_per_key) {
            md = md_per_key[key];
        }
        return md;
    }

    function editorForFloat(key) {
        let md = mdForKey(key);
        if(md) {
            return <MetadataEditor nolabel={true} metadata={md} width={120}/>
        }
        return <Button onClick={() => {
            let newMetadata = {
                SKU: product,
                key: key,
                svalue: null,
                ivalue: null,
                fvalue: 0.0
            }
            addMeta(newMetadata); 
        }}><AddIcon /></Button>;
    }

    function valueForFloat(key) {
        let md = mdForKey(key);
        return md ? md.fvalue : "";
    }

    function cellValueForFloat(key) {
        return editing ?
            editorForFloat(key)
                :
            valueForFloat(key);
    }
    
    return <TableRow key={product.id}>
        <TableCell><Link underline="none" variant="body" target={makeLinkToProduct(product)}>{product.code}</Link></TableCell>
        <TableCell><Link underline="none" color="inherit" variant="body" target={makeLinkToProduct(product)}>{product.name}</Link></TableCell>
        <TableCell>{product.stock}</TableCell>
        <TableCell>{product.item_type}</TableCell>
        <TableCell>{product.item_type !== "group" ? cellValueForFloat("weight") : valueForFloat("weight")}</TableCell>
      </TableRow>;
}

export {ProductHeader, ProductRow};
